export enum InvoiceSentState {
  Opened = 'opened',
  Printed = 'printed',
  Sent = 'sent',
  Unsent = 'unsent',
  Viewed = 'viewed',
}
